module.exports = __webpack_public_path__ + "static/media/Mano 1.eece518e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Mano 1.png
// module id = 183
// module chunks = 0